import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_notification_scheduler_RowClass } from '../../../dbschema/bl_cms_notification_scheduler.model';

export class CmsNotificationSchedulerContainer extends BaseContainerModel {
  bl_cms_notification_scheduler: bl_cms_notification_scheduler_RowClass = new bl_cms_notification_scheduler_RowClass();
}